import React, { useState } from 'react';
import { Upload } from 'lucide-react';

const DeckDropZone = ({ deckId, isActive, onDrop, disabled }) => {
  const [isDragOver, setIsDragOver] = useState(false);

  const handleDragOver = (e) => {
    if (disabled) return;
    e.preventDefault();
    e.dataTransfer.dropEffect = 'move';
    setIsDragOver(true);
  };

  const handleDragLeave = () => {
    setIsDragOver(false);
  };

  const handleDrop = (e) => {
    if (disabled) return;
    e.preventDefault();
    setIsDragOver(false);

    try {
      const data = JSON.parse(e.dataTransfer.getData('application/json'));
      if (data.track && onDrop) {
        // Pass modifier keys to handler for advanced drop behavior
        const modifiers = {
          shift: e.shiftKey,
          ctrl: e.ctrlKey,
          alt: e.altKey,
          meta: e.metaKey
        };
        onDrop(deckId, data.track, data.index, modifiers);
      }
    } catch (error) {
      console.error('Error handling drop:', error);
    }
  };

  if (disabled) return null;

  return (
    <div
      onDragOver={handleDragOver}
      onDragLeave={handleDragLeave}
      onDrop={handleDrop}
      className={`absolute inset-0 transition-all ${
        isDragOver
          ? 'bg-purple-500/20 border-4 border-dashed border-purple-400 z-50 pointer-events-auto'
          : 'border-2 border-dashed border-transparent pointer-events-none'
      }`}
    >
      {isDragOver && (
        <div className="flex items-center justify-center h-full">
          <div className="text-center bg-dark-card/90 px-6 py-4 rounded-xl border border-sunset-orange max-w-sm">
            <Upload className="w-8 h-8 text-purple-400 mx-auto mb-2" />
            <p className="text-white font-semibold">
              Charger sur Deck {deckId}
            </p>
            <p className="text-xs text-sunset-orange mt-1">
              Ce titre sera prêt à jouer
            </p>
            <div className="text-xs text-purple-400/60 mt-3 space-y-1">
              <p>💡 Astuce: Maintenez Shift pour "Jouer ensuite"</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeckDropZone;
